import { createFileRoute, notFound } from "@tanstack/react-router";

import { BestPage } from "../components/best/BestPage";
import { bestHead } from "../lib/best/head";
import { bestSlugOf, loadBestCopy } from "../lib/best/index";
import { BEST_UI } from "../lib/best/ui";
import { documentHeaders } from "../lib/seo";

/**
 * `/best/<slug>`, in English.
 *
 * A new address — v1 had no listicles at all, which `lib/best/types.ts` records
 * as the largest single gap against the citation research.
 */
export const Route = createFileRoute("/best/$slug")({
  loader: async ({ params }) => {
    const slug = bestSlugOf(params.slug);
    if (!slug) throw notFound();
    return { slug, copy: await loadBestCopy("en") };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? bestHead(
          loaderData.slug,
          "en",
          loaderData.copy[loaderData.slug],
          BEST_UI.en,
        )
      : {},
  component: EnglishBest,
});

function EnglishBest() {
  const { slug, copy } = Route.useLoaderData();
  return (
    <BestPage
      slug={slug}
      copy={copy[slug]}
      ui={BEST_UI.en}
      lang="en"
      allCopy={copy}
    />
  );
}
